import { AktuelleNachrichten } from '../main/AktuelleNachrichten';
import { ApiService } from '../services/api_service';
import * as config from '../wips.config.js';
import { DataService } from '../services/data_service';
import DialogWrapper2 from '../core/dialog/dialog_wrapper_v2';
import { i18n } from '../i18n/i18n';
import { IDs } from '../helpers/IDs';
import img_start1 from '../img/start_1.jpg';
import img_start2 from '../img/start_2.jpg';
import img_start3 from '../img/start_3.jpg';
import img_start_logos from '../img/start_logos.jpg';
import { InfoDialog } from './InfoDialog';
import { Kontakt } from '../main/Kontakt';
import { lazyInject } from '../services/inversify';
import { LoginBestimmungen } from './LoginBestimmungen';
import './loginForm.module.css'
import '../style/main.css';
import { MehrsprachigkeitFaq } from '../admin/bereiche/datenverwaltung/mehrsprachigkeit/MehrsprachigkeitFaq';
import parse from 'html-react-parser';
import * as React from 'react';
import ReactPlayer from 'react-player'
import { Tour } from '../bereiche/start/Tour';
import { Versionen } from '../helpers/versionen';
import { WFormsTableWrapper } from '../core/table/WFormsTableWrapper';

interface LoginFormProps extends React.ClassAttributes<any> {
    adminMode?: boolean;
    miniLogin?: boolean;
    userNamePreset?: string;
    confirmLogin?: boolean;
    img?: string;
    img2?: string;
    params?: any;
    data?: any;
    isExterneRegistrierung?: boolean;
    externeRegistrierungPresetData?: any;
    setUserToken?: (userName: string, auth?: any) => void;
    setTidPass?: (userName: string, tid: number, pass: string) => void;
}

interface LoginFormState extends React.ClassAttributes<any> {
    userName: string;
    password: string;
    errorUser: boolean;
    errorPass: boolean;
    showDlgRegi: boolean;
    showDlgConfirmEmail: boolean;
    showDlgFaq: boolean;
    showDlgKontakt: boolean;
    showDlgTour: boolean;
    showDlgValidierung: boolean;
    showDlgTrailer: string;
    showDlgPartnerLogin: boolean;
    confirmMailAddress: string;
    alleRegiBedingungenChecked: boolean;
    showInfoDialog: string;
    disabledBtnConfirmEmail: boolean;
    beraterInfo?: any;
    validierungInfo?: any;
    partnerLoginInfo?: any;
    bereicheData: any[];
    onNarrowScreen: boolean;
}

export class LoginForm extends React.Component<LoginFormProps, LoginFormState> {

    constructor(props: any) {
        super(props);
        const params = props.params;
        this.state = {
            userName: props.userNamePreset ? props.userNamePreset : '',
            password: '',
            errorUser: props.confirmLogin === true && props.userNamePreset ? false : true,
            errorPass: true,
            showDlgRegi: ((params && +params.register === 1) || props.isExterneRegistrierung) ? true : false,
            showDlgConfirmEmail: false,
            showDlgFaq: false,
            showDlgKontakt: false,
            showDlgTour: false,
            showDlgValidierung: false,
            showDlgTrailer: null,
            showDlgPartnerLogin: false,
            confirmMailAddress: '',
            alleRegiBedingungenChecked: false,
            showInfoDialog: undefined,
            disabledBtnConfirmEmail: false,
            bereicheData: null,
            onNarrowScreen: false
        };
        this.handleLogin = this.handleLogin.bind(this);
        this.onChangeUserName = this.onChangeUserName.bind(this);
        this.onChangeUserPass = this.onChangeUserPass.bind(this);
        this.onKeyPressLogin = this.onKeyPressLogin.bind(this);
        this.onDocumentResize = this.onDocumentResize.bind(this);
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(DataService) private dataService: DataService;

    private devFeaturesMap: any = config.devFeaturesMap || {};

    componentDidMount(): void {
        const params = this.props.params;
        if (params && params.login && params.password) {
            this.setState({ userName: params.login, password: params.password }, this.handleLogin);
        }

        if (params && params.adminUser && params.adminToken) {
            this.setState({ userName: params.adminUser }, () => this.handleLogin(null, params.adminToken));
        }

        this.dataService.loadDataForModul(IDs.ENT_SYSTEMTEXTE, { name: 'registrierung_beraterinfo' },
            {}, IDs.MOD_ETOOL_ADMIN, (result: any) => {
                if (result.systemtexte && result.systemtexte && result.systemtexte[0] && result.systemtexte[0].beschreibung) {
                    const beraterInfo = parse(result.systemtexte[0].beschreibung);
                    this.setState({ beraterInfo });
                } else {
                    this.setState({ beraterInfo: null });
                }
        });
        this.dataService.loadDataForModul(IDs.ENT_SYSTEMTEXTE, { name: 'validierung_info' },
            {}, IDs.MOD_ETOOL_ADMIN, (result: any) => {
                if (result.systemtexte && result.systemtexte && result.systemtexte[0] && result.systemtexte[0].beschreibung) {
                    const validierungInfo = parse(result.systemtexte[0].beschreibung);
                    this.setState({ validierungInfo });
                } else {
                    this.setState({ validierungInfo: null });
                }
        });

        this.dataService.loadDataForModul(IDs.ENT_SYSTEMTEXTE, { name: 'info_partner_login' },
            {}, IDs.MOD_ETOOL_ADMIN, (result: any) => {
                if (result.systemtexte && result.systemtexte && result.systemtexte[0] && result.systemtexte[0].beschreibung) {
                    const partnerLoginInfo = parse(result.systemtexte[0].beschreibung);
                    this.setState({ partnerLoginInfo });
                } else {
                    this.setState({ partnerLoginInfo: null });
                }
        });

        this.dataService.loadData(IDs.ENT_BRANCHEN_BEREICHE, {}, {}, (res: any) => {
            if (res && Array.isArray(res[IDs.ENT_BRANCHEN_BEREICHE])) {
                const bereicheData = res[IDs.ENT_BRANCHEN_BEREICHE].filter((r: any) => r.intern_key !== 'kommunalverwaltung');
                this.setState({ bereicheData });
            }
        }, IDs.MOD_ETOOL_ADMIN);

        window.addEventListener('resize', this.onDocumentResize);
        this.onDocumentResize();
    }

    componentWillUnmount(): void {
        window.removeEventListener('resize', this.onDocumentResize);
    }

    onDocumentResize() {
        // console.log(window.document.body.clientWidth);
        if (window.document.body.clientWidth < 1100) {
            if (!this.state.onNarrowScreen) {
                this.setState({ onNarrowScreen: true })
            }
        } else {
            if (this.state.onNarrowScreen) {
                this.setState({ onNarrowScreen: false })
            }
        }
    }

    handleLogin(e?: any, adminToken?: string): void {
        if (e) {
            e.preventDefault();
        }
        if (this.state.userName) {
            const user = this.state.userName;
            const pass = this.state.password;
            const { adminMode, confirmLogin, setUserToken, setTidPass } = this.props;
            // Beim Login wird erst geprüft, ob es in der Registrierungs-Tabelle einen Login gibt
            this.apiService.call('checkCredentials', { user, pass, module: IDs.MOD_ETOOL_ADMIN, isHash: false, adminToken },
                (data: string, suc: boolean) => {
                    // console.log('Login 1: checkCredentials', data, suc);
                    if (suc) {
                        const obj = JSON.parse(data);
                        if (!obj || parseInt(obj.granted, 10) === 0 || (adminMode && parseInt(obj.is_admin, 10) !== 1)) {
                            // Falls nicht, dann in der "normalen" User-Tabelle.
                            if (!adminMode) {
                                this.apiService.call('checkCredentialsRegi', {
                                    user, pass, module: IDs.MOD_ETOOL_ADMIN, isHash: false,
                                    requestTid: confirmLogin === true ? true : false
                                },
                                    (dataLoaded: string, suc2: boolean) => {
                                        // console.log('Login 2: checkCredentialsRegi', dataLoaded, suc2);
                                        if (suc2) {
                                            const objLoaded = JSON.parse(dataLoaded);
                                            if (!objLoaded || parseInt(objLoaded.granted, 10) === 0) {
                                                alert('Login ungültig');
                                            } else if (parseInt(objLoaded.granted, 10) === -1) {
                                                alert('Ihre E-Mail-Adresse ist nicht bestätigt, oder Ihrer Zugang ist nicht freigeschaltet.');
                                            } else {
                                                if (setUserToken) {
                                                    setUserToken(this.state.userName, objLoaded);
                                                }
                                                if (confirmLogin === true && setTidPass) {
                                                    setTidPass(this.state.userName, objLoaded.tid, this.state.password);
                                                }
                                            }
                                        } else {
                                            alert('Login fehlgeschlagen');
                                        }
                                    });
                            } else {
                                alert('Login ungültig');
                            }
                        } else {
                            if (setUserToken) {
                                const userName = obj.login ? obj.login : this.state.userName;
                                setUserToken(userName, obj);
                            }
                        }
                    } else {
                        alert('Login fehlgeschlagen');
                    }
                });
        }
    }

    onChangeUserName(e: any): void {
        const userName = e.target.value;
        this.setState({ userName });
        if (userName && userName !== '') {
            this.setState({ errorUser: false });
        } else {
            this.setState({ errorUser: true });
        }
    }

    onChangeUserPass(e: any): void {
        const password = e.target.value;
        this.setState({ password });
        if (password && password !== '') {
            this.setState({ errorPass: false });
        } else {
            this.setState({ errorPass: true });
        }
    }

    onKeyPressLogin(e: any): void {
        if (e.key === 'Enter') {
            this.handleLogin(e);
        }
    }

    render(): JSX.Element {
        if (false && this.props.miniLogin) {
            // return this.renderMini();
        }
        return this.renderMain();
    }

    renderMain(): JSX.Element {
        const showAktuelleNachrichten = true;
        let logo_etool;
        let img_validiert;
        let backgroundImage;

        if(config.instance && config.instance === 'lux') { // Später Instance + Brand, z.B. direkt über Dateinamen "Logo_lux_cc.png" oder so ...
            if(!config.brand) {
                backgroundImage = require('../img/e-tool_login_background.jpg');
                logo_etool = require('../icons/logos/Logo_Lux.png');
            } else
            if(config.brand === 'cc') {
                backgroundImage = require('../img/e-tool_login_background_cc.png');
                logo_etool = require('../icons/logos/Logo_Lux_CC.png');
            } else
            if(config.brand === 'ka') {
                backgroundImage = require('../img/e-tool_login_background_ka.png');
                logo_etool = require('../icons/logos/Logo_Lux_KA.png');
            }
            img_validiert =  require('../img/banner_lux.png');
        } else {
            backgroundImage = require('../img/e-tool_login_background.jpg');
            logo_etool = require('../icons/logos/SO_Logo_Auswertung.png');               
            img_validiert =  require('../img/validiert.png');
        }
        const cssBackGroundImage = {
            '--login-bg-image': `url(${backgroundImage})`
        };

        const logo_mie = require('../img/MIE_LOGO_Nebeneinander_weiß.png');
        const logo_bwe = require('../img/logo_bwe_energiewechsel.png');
        const logo_bmwie = require('../img/logo_bmwi_partner.png');
        const logo_nki = require('../img/logo_nki.png');
        const logo_zdh = require('../img/logo_zdh.png');
        const logo_ka = require('../img/logo_ka.png');
        const logo_cc = require('../img/logo_cc.png');


        const icon_play = require('../icons/play_circle_24dp.svg');
        const icon_outbound = require('../icons/outbound_24dp.svg');

        return (
            <div>
                <div
                    className='login-page'
                    style={cssBackGroundImage as React.CSSProperties}
                >
                    <div className='valid-wrapper'>
                        <img
                            onClick={() => this.setState({ showDlgValidierung: true })}
                            src={img_validiert}
                            style={{ border: 0, position: 'fixed', left: this.props.adminMode ? -38 : -38, top: 16, cursor: 'pointer', transform: 'rotate(-83deg)' }}
                            alt='Vorsprung durch Transparenz!'
                        />
                    </div>

                    <div className='card-container'>
                        <div className='flex-wrapper'>
                            <div className='col-login'>
                                <div>
                                    <div className='logo'>
                                        <img src={logo_etool} alt='Logo' />
                                    </div>
                                    <ul className='features-list'>
                                        <li>kostenfreie Anmeldung & Nutzung</li>
                                        <li>Energiebedarf optimieren & sparen</li>
                                        <li>CO₂-Fußabdruck/THG-Bilanz erstellen</li>
                                    </ul>
                                    <div className='login-form'>
                                        <h3>Login:</h3>
                                        <p>Bitte melden Sie sich im E-Tool an:</p>

                                        <div className='input-group'>
                                            <input
                                                type='text'
                                                placeholder='Benutzer:'
                                                value={this.state.userName}
                                                onKeyPress={this.onKeyPressLogin}
                                                onChange={this.onChangeUserName}
                                            />
                                            <i className='far fa-user'></i>
                                        </div>
                                        <div className='input-group'>
                                            <input
                                                type='password'
                                                placeholder='Passwort:'
                                                value={this.state.password}
                                                onKeyPress={this.onKeyPressLogin}
                                                onChange={this.onChangeUserPass}
                                            />
                                            <i className='far fa-eye-slash'></i>
                                        </div>
                                        {/*<div className="checkbox-group">
                                            <input type="checkbox" id="remember" />
                                            <label>an mich erinnern</label>
                                        </div>*/}

                                        <button
                                            className='btn-login'
                                            onClick={this.handleLogin}
                                            disabled={this.state.errorUser || this.state.errorPass}
                                        >Login</button>

                                        <div className='form-footer'>
                                            Sie haben keinen Account? <a
                                                href='#'
                                                onClick={() => this.setState({ showDlgRegi: true })}
                                            ><span>Registrieren!</span>
                                            </a><br />
                                            <hr />
                                            <a
                                                href='#'
                                                onClick={() => this.setState({ showDlgConfirmEmail: true })}
                                            >Passwort vergessen?</a>
                                        </div>

                                        <button
                                            className='btn-login-partner'
                                            onClick={() => this.setState({showDlgPartnerLogin: true}, () => {
                                                // console.log('blubb...', this.state.showDlgPartnerLogin);
                                            }) }
                                        >als <span>Partner</span> einloggen</button>

                                    </div>
                                </div>
                            </div>

                            <div className='col-info'>
                                <div className='info-block'>
                                    <div className="section-header">News:</div>
                                    <div className="scroll-content">
                                        <AktuelleNachrichten
                                            entity={IDs.ENT_AKTUELLE_NACHRICHTEN}
                                            onNarrowScreen={this.state.onNarrowScreen}
                                        />
                                        {/*
                                        <div className="news-item">
                                            <span className="date"><i className="far fa-file-alt"></i> 10.10.2025</span>
                                            e-Tool Funktionen im Check: Betriebsvergleich &rarr;
                                        </div>
                                        <div className="news-item">
                                            <span className="date"><i className="far fa-file-alt"></i> 05.09.2025</span>
                                            e-Tool jetzt offiziell GHG-konform! &rarr;
                                        </div>
                                        <div className="news-item">
                                            <span className="date"><i className="far fa-file-alt"></i> 28.08.2025</span>
                                            e-Tool überzeugt im Marktvergleich &rarr;
                                        </div>*/}
                                    </div>
                                </div>

                                <div className='info-block'>
                                    <div className="section-header">Termine:</div>
                                    <div className="scroll-content">
                                        <AktuelleNachrichten
                                            entity={IDs.ENT_AKTUELLE_TERMINE}
                                            onNarrowScreen={this.state.onNarrowScreen}
                                        />
                                        {/*
                                        <div className="news-item">
                                            <span className="date"><i className="far fa-calendar"></i> 09.12.2025</span>
                                            e-Tool Sprechstunde von 10:00 bis 11:00 Uhr &rarr;
                                        </div>
                                        <div className="news-item">
                                            <span className="date"><i className="far fa-calendar"></i> 14.01.2026</span>
                                            Energie- & Emissionsbilanzierung mit dem kostenlosen e-Tool - Einführung &rarr;
                                        </div>
                                        */}
                                    </div>
                                </div>
                            </div>

                            <div className='col-media'>
                                <div className="media-box">
                                    <a
                                        href='#'
                                        style={{ color: '#FFF' }}
                                        onClick={() => this.setState({ showDlgTrailer: 'E-Tool_Trailer_kurz.mp4' })}
                                    >
                                        <div><img src={icon_play} /></div>
                                        <div style={{ color: '#FFF' }}>Was ist eigentlich<br />das E-Tool?</div>
                                    </a>
                                </div>
                                <div className="media-box media-box-2">
                                    <a
                                        href='#'
                                        onClick={() => this.setState({ showDlgTour: true })}
                                    >
                                        <div><img src={icon_play} /></div>
                                        <div style={{ color: '#FFF' }}>Info-Tour durch<br />das E-Tool...</div>
                                    </a>
                                </div>
                                <div className="media-box media-box-3">
                                    <a href='https://energieeffizienz-handwerk.de/' target='_blank'>
                                        <div><img src={icon_outbound} /></div>
                                        <div><img className='logo-mie' src={logo_mie} /></div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='card-container-mirror'>
                        {(!config.instance || config.instance === 'de') && <div className='image-row'>
                            <img className='logo-bmwie' src={logo_bmwie} alt='' />
                            <img className='logo-nki' src={logo_nki} alt='' />
                            <img className='logo-bwe' src={logo_bwe} alt='' />
                            <img className='logo-zdh' src={logo_zdh} alt='' />
                        </div>}
                       {(config.instance && config.instance === 'lux') && <div className='image-row'>
                            <img className='logo-ka' src={logo_ka} alt='' />
                            <img className='logo-cc' src={logo_cc} alt='' />
                        </div>}
                    </div>

                    <div className='login-footer'>
                        <div className='login-footer-left'>
                            <span onClick={() => this.setState({ showDlgFaq: true })}>
                                E-Tool FAQ
                            </span> &nbsp;&middot;&nbsp;
                            <a href='mailto: service@energie-tool.de'>Kontakt</a> &nbsp;&middot;&nbsp;
                            <a
                                href='#'
                                onClick={() => this.setState({ showInfoDialog: 'Nutzungsbedingungen' })}
                            >Nutzungsbedingungen</a> &nbsp;&middot;&nbsp;
                            <a
                                href='#'
                                onClick={() => this.setState({ showInfoDialog: 'Datenschutz' })}
                            >Datenschutz</a> &nbsp;&middot;&nbsp;
                            <a
                                href='#'
                                onClick={() => this.setState({ showInfoDialog: 'Impressum' })}
                            >Impressum</a>
                        </div>
                        <div className='login-footer-right'>
                            Version {Versionen.VERSION} &middot; CFM {Versionen.VERSION_CFM}
                        </div>
                    </div>

                </div>
                {this.state.showDlgRegi && this.state.bereicheData && this.renderDlgRegi()}
                {this.state.showDlgConfirmEmail && this.renderDlgConfirmEmail()}
                {this.state.showDlgValidierung && this.renderDlgValidierung()}
                {this.state.showDlgKontakt && <Kontakt onClose={() => this.setState({ showDlgKontakt: false })} />}
                {this.state.showInfoDialog && this.renderInfoDialog()}
                {this.state.showDlgFaq && this.renderDlgFaq()}
                {this.state.showDlgTour && this.renderDlgTour()}
                {this.state.showDlgTrailer && this.renderDlgTrailer()}
                {this.state.showDlgPartnerLogin && this.renderDlgPartnerLogin()}
            </div>

        );
    }

    renderPreLoads(): JSX.Element {
        const imgs: any[] = [
            require('../img/start_info.jpg'),
            require('../img/Tour1.png'),
            require('../img/Tour2.png'),
            require('../img/Tour3.png'),
            require('../img/Tour4.png'),
            require('../img/Tour5.png'),
            require('../img/Tour6.png'),
            require('../img/Tour7.png'),
            require('../img/Allgemein.png'),
        ];

        return (
            <>
                {imgs.map((img: any, idx: number) =>
                    <img
                        src={img}
                        key={`img_pl_${idx}`}
                        style={{ maxWidth: 0 }}
                        alt=''
                    />
                )}
            </>
        );
    }

    /*
    renderMini(): JSX.Element {
        const loginIcon = require('../img/loginBtn.png');

        // Nur das Registrierungsformular rendern
        if (this.props.isExterneRegistrierung && this.state.bereicheData) {
            return this.renderDlgRegi();
        }

        // wir müssen zwingend auf die Bereiche warten...
        if (this.props.isExterneRegistrierung && !this.state.bereicheData) {
            return null;
        }

        return (
            <div>
                <div className={styleMain.loginBoxMini}>
                    <div style={{ display: 'flex' }}>
                        <input
                            type='text' name='userName' placeholder='Anmeldename'
                            onKeyPress={this.onKeyPressLogin}
                            onChange={this.onChangeUserName}
                        />
                        <input
                            style={{ marginLeft: 3 }}
                            type='password' name='userPass' placeholder='Kennwort'
                            onKeyPress={this.onKeyPressLogin}
                            onChange={this.onChangeUserPass}
                        />
                        <img
                            style={{ marginLeft: 3 }}
                            src={loginIcon}
                            className={styleMain.btnLogin}
                            onClick={this.handleLogin}
                        />
                    </div>
                    <div>
                        <a
                            className={styleMain.textBtn}
                            onClick={() => this.setState({ showDlgRegi: true })}
                        >
                            Neu Registrieren
                        </a>
                        &nbsp;|&nbsp;
                        <a
                            className={styleMain.textBtn}
                            onClick={() => this.setState({ showDlgConfirmEmail: true })}
                        >
                            Passwort vergessen
                        </a>
                        {!this.props.adminMode &&
                            <span>&nbsp;|&nbsp;
                                <a
                                    className={styleMain.textBtn}
                                    onClick={() => window.location.assign(config.zwh_login_url)}
                                >
                                    Anmelden über ZWH
                                </a>
                            </span>
                        }
                    </div>
                </div>
                {this.state.showDlgRegi && this.state.bereicheData && this.renderDlgRegi()}
                {this.state.showDlgConfirmEmail && this.renderDlgConfirmEmail()}
                {this.state.showInfoDialog && this.renderInfoDialog()}
            </div>
        );
    }
    */
    renderDlgValidierung(): JSX.Element {
        return (
            <DialogWrapper2
                title='E-Tool: Verifiziert und ausgezeichnet!'
                width={-1}
                onAfterClose={() => this.setState({ showDlgValidierung: false })}
            >
                <div
                    style={{
                        width: 1350, height: '100vh', margin: '0 0 20px 20px', paddingTop: 10, paddingRight: 20, display: 'flex',
                        flexDirection: 'column', overflowY: 'auto'
                    }}
                >
                    {this.state.validierungInfo}
                </div>
            </DialogWrapper2>
        );
    }

    renderDlgConfirmEmail(): JSX.Element {
        const styleButton: React.CSSProperties = { fontSize: 12, marginTop: 20, padding: 5/*, boxShadow: '0 0 5px rgba(0, 0, 0, 0.75)'*/ };
        return (
            <DialogWrapper2
                width={-1}
                verticalAlignCenter
                onAfterClose={() => this.setState({ showDlgConfirmEmail: false, confirmMailAddress: '' })}
            >
                <div
                    style={{
                        backgroundColor: 'var(--color-wform-background)', width: 400, height: 300, paddingBottom: 58,
                        borderBottomRightRadius: 'var(--border-radius-dialog)', borderBottomLeftRadius: 'var(--border-radius-dialog)',
                        display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center'
                    }}
                >
                    {/* <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline' }}>
                        <div>Ich bin</div>
                        <select
                            style={{ marginLeft: 10 }}
                            value={this.state.confirmMailEntity}
                            onChange={(evt: any) => this.setState({ confirmMailEntity: evt.target.value })}
                        >
                            <option value={IDs.ENT_REGISTRIERUNG}>Hauptnutzer:in</option>
                            <option value={IDs.ENT_MANDANTEN_USER}>Zusatzutzer:in</option>
                            <option value={IDs.ENT_BERATER}>Berater:in</option>
                        </select>
                    </div> */}
                    <input
                        style={{ textAlign: 'center', width: 300, marginTop: 10, padding: 5 }}
                        type='text' value={this.state.confirmMailAddress}
                        onChange={(evt: any) => this.setState({ confirmMailAddress: evt.target.value })}
                    />
                    <div style={{ width: 350, fontSize: '0.8em', textAlign: 'center', marginTop: 5 }}>
                        Bitte die E-Mail-Adresse, die Sie bei der Registrierung angegeben haben, ausfüllen
                    </div>
                    <button
                        style={styleButton}
                        className='textButton'
                        // className={style.basic}
                        disabled={this.state.disabledBtnConfirmEmail}
                        onClick={() => {
                            const mail = this.state.confirmMailAddress;
                            if (this.validateEmail(mail)) {
                                this.setState({ disabledBtnConfirmEmail: true }, () => {
                                    this.apiService.call('resetPasswordConfirm', { mail, module: IDs.MOD_ETOOL_ADMIN },
                                        (res: string, suc: boolean) => {
                                            // console.log(res, suc);
                                            if (suc) {
                                                if (res === '1') {
                                                    alert('Eine E-Mail zur Bestätigung wurde an diese E-Mail-Adresse gesendet.');
                                                    this.setState({ showDlgConfirmEmail: false, confirmMailAddress: '' });
                                                } else {
                                                    alert('Die E-Mail-Adresse ist nicht vorhanden!');
                                                }
                                            } else {
                                                alert('Fehlgeschlagen');
                                            }
                                            this.setState({ disabledBtnConfirmEmail: false });
                                        }
                                    );
                                });
                            } else {
                                alert('Bitte geben Sie eine gültige E-Mail-Adresse an!');
                            }
                        }}
                    >
                        Passwort zurücksetzen
                    </button>
                </div>
            </DialogWrapper2>
        );
    }

    renderInfoDialog(): JSX.Element {
        const { showInfoDialog: name } = this.state;

        return (
            <DialogWrapper2
                title={name || ''}
                width={940}
                onAfterClose={() => this.setState({ showInfoDialog: undefined })}
            >
                <InfoDialog name={name} />
            </DialogWrapper2>
        );
    }

    renderDlgFaq(): JSX.Element {
        return (
            <DialogWrapper2
                title='FAQ'
                width={-1}
                onAfterClose={() => this.setState({ showDlgFaq: undefined })}
            >
                <div style={{ width: '90vw', maxWidth: 1350, minHeight: 0, display: 'flex', flex: 1, flexDirection: 'column' }}>
                    <MehrsprachigkeitFaq
                        data={this.props.data}
                        isDialog
                        isPublic
                    />
                </div>
            </DialogWrapper2>
        );
    }

    renderDlgRegi(): JSX.Element {
        const config: any = require('../wips.config.js');
        const customValidate = (key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string => {
            if (key === 'name') {
                if (value && value !== '') {
                    const newVal = value.replace(/[^A-Za-zöäüÖÄÜß\-]/g, '');
                    if (newVal !== value) {
                        onValueChange('name', newVal);
                    }
                }
            }
            if (key === 'vorname') {
                if (value && value !== '') {
                    const newVal = value.replace(/[^A-Za-zöäüÖÄÜß\-\. ]/g, '');
                    if (newVal !== value) {
                        onValueChange('vorname', newVal);
                    }
                }
            }
            if (key === 'plz') {
                if (value && value !== '') {
                    const newVal = value.replace(/[^0-9]/g, '').substr(0, 5);
                    if (newVal !== value) {
                        onValueChange('plz', newVal);
                    }
                }
            }
            if (key === 'telefon') {
                if (value && value !== '') {
                    const newVal = value.replace(/[^0-9+-/]/g, '');
                    if (newVal !== value) {
                        onValueChange('telefon', newVal);
                    }
                }
            }
            return undefined;
        };

        let formPreset: any = { mail_confirmed: 0, active: 0 };
        const customFormConfig: any = {
            password: {
                validMsgStyle: { marginTop: -42 }
            }
        };

        if (config.preset_bereich) {
            formPreset.bereich_key = config.preset_bereich;
            customFormConfig.bereich_key = { hidden: true };
        }

        if (this.props.externeRegistrierungPresetData) {
            formPreset = { ...formPreset, ...this.props.externeRegistrierungPresetData };
        }

        const optionalFields = ['name', 'vorname', 'strasse', 'hausnummer', 'ort', 'plz', 'telefon']
        if (this.props.isExterneRegistrierung && this.props.externeRegistrierungPresetData.uuid) {
            optionalFields.unshift('uuid');
        }

        return (
            <WFormsTableWrapper
                key={'register_form'}
                entity={IDs.ENT_REGISTRIERUNG}
                module={IDs.MOD_ETOOL_ADMIN}
                useTheme={1}
                directEditFormularOf={{ tid: 0 }}
                validRestriction={'stop'}
                validateField={customValidate}
                formPreset={formPreset}
                customFormConfig={customFormConfig}
                preFilterServer={{ tid: 0 }}
                inlineFormular={this.props.isExterneRegistrierung}
                externalFormTopElement={this.state.beraterInfo &&
                    <div style={{ margin: 10, marginLeft: 13, borderBottom: '1px solid #918f8f' }}>
                        {this.state.beraterInfo}
                    </div>
                }
                onAfterAction={(action: string) => {
                    if (action === 'closeForm') {
                        this.setState({ showDlgRegi: false });
                    }
                }}
                onSaveDone={(entity: string, values: any) => {
                    if (!this.props.isExterneRegistrierung) {
                        this.setState({ showDlgRegi: false });
                    }
                    let closeInfo = '';
                    if (this.props.isExterneRegistrierung) {
                        closeInfo = '\r\n\r\nSie können dieses Fenster nun schließen.';
                    }
                    alert(
                        'Sie erhalten eine Bestätigung per E-Mail. \n\r'
                        + 'Gehen Sie zu Ihrem E-Mail-Posteingang und öffnen Sie die Bestätigungs-E-Mail mit dem Betreff „Bestätigen Sie Ihre E-Mail-Adresse“. \n\r'
                        + 'Klicken Sie auf den Bestätigungslink in der E-Mail. \n\r'
                        + 'Falls Sie in Ihrem Posteingang keine Bestätigungs-Nachricht zum E-Tool finden, schauen Sie bitte auch in Ihrem SPAM/Junk-Ordner.'
                        + closeInfo
                    );
                }}
                settingsForLoad={{ bundle: false }}
                formLayout='flowV2'
                customClass={'Custom-ETA'}
                formSimpleValidationMsg={['unternehmen', 'bereich_key', 'mail']}
                customCssStyle={{
                    formcontainer: { paddingLeft: 12 },
                    validationWarning: { marginLeft: 10 },
                }}
                formGroupOrder={[
                    {
                        title: i18n('Pflichtangaben', 'sys'),
                        titleStyle: { fontSize: '13pt', fontWeight: 'bold', color: '#5e5e5e' },
                        foldable: false,
                        folded: false,
                        fields: ['unternehmen', 'bereich_key', 'mail', 'password']
                    },
                    {
                        title: i18n('Optionale Angaben', 'sys'),
                        titleStyle: { fontSize: '13pt', fontWeight: 'bold', color: '#5e5e5e' },
                        foldable: true,
                        folded: true,
                        fields: optionalFields
                    }
                ]}
                bundle={{ bereich_key: this.state.bereicheData }}
                extraFormElementAfter={{
                    password: <div style={{ marginBottom: 30, paddingRight: 10 }}>
                        <LoginBestimmungen
                            onChange={(allChecked: boolean) => this.setState({ alleRegiBedingungenChecked: allChecked })}
                        />
                    </div>
                }}
                callBeforeOnFormSave={(data: any, callback: () => void) => {
                    console.log('saveData', data);
                    if (!this.state.alleRegiBedingungenChecked) {
                        alert('Bitte akzeptieren Sie Nutzungsbedingungen und Datenschutzhinweise !');
                    } else {
                        if (data.mail) {
                            this.apiService.call('checkMailExistence', { mail: data.mail, tid: data.tid, entity: IDs.ENT_REGISTRIERUNG, module: IDs.MOD_ETOOL_ADMIN },
                                (res: string, suc: boolean) => {
                                    // console.log(res, suc);
                                    if (suc) {
                                        if (res === '1') {
                                            alert('E-Mail-Adresse existiert bereits.');
                                        } else {
                                            callback();
                                        }
                                    } else {
                                        alert('Server Error');
                                    }
                                }
                            );
                        }
                    }
                }}
            />
        );
    }

    renderDlgPartnerLogin(): JSX.Element {
        const logo_zwh = require('../img/Logo_zwh_2023_RGB.svg');
        return(
            <DialogWrapper2
                title='Mit Partner-Login einloggen'
                width={-1}
                onAfterClose={() => this.setState({ showDlgPartnerLogin: false })}
            >
                <div
                    style={{
                        backgroundColor: 'var(--color-wform-background)', width: 565, height: 300, padding: 20,
                        borderBottomRightRadius: 'var(--border-radius-dialog)', borderBottomLeftRadius: 'var(--border-radius-dialog)',
                        display: 'flex', flex: 1, flexDirection: 'column'
                    }}
                >
                    <div style={{
                        borderBottom: '1px solid var(--color-bg-highlight)'
                    }}>
                        {this.state.partnerLoginInfo}
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginTop: 20
                        }}
                    >
                        <div>
                            <img
                                onClick={() => window.location.assign(config.zwh_login_url)}
                                src={logo_zwh}
                                style={{
                                    width: 100,
                                    cursor: 'pointer',
                                    // backgroundColor: '#1f374d'
                                }}
                                alt='ZWH: Zentralstelle für die Weiterbildung im Handwerk e. V.'
                        /></div>
                        <div>
                            <a
                                href='#'
                                onClick={() => window.location.assign(config.zwh_login_url)}
                            >Zentralstelle für die Weiterbildung im Handwerk e. V.</a></div>
                    </div>
                </div>
            </DialogWrapper2>
        );
    }

    renderDlgTour(): JSX.Element {
        return (
            <DialogWrapper2
                title='E-Tool: Info-Tour'
                width={-1}
                verticalAlignCenter
                onAfterClose={() => this.setState({ showDlgTour: null })}
            >
                <Tour />
            </DialogWrapper2>
        );
    }

    renderDlgTrailer(): JSX.Element {
        const config: any = require('../wips.config.js');
        let url: string = (config.api_url || '').split('/wips_api');
        url = url.length > 1 ? url[0] : null;
        url = url ? `${url}/trailer/${this.state.showDlgTrailer}` : null;

        return (
            <DialogWrapper2
                styleClassExternal='player'
                title='E-Tool: Vorschaufilm'
                width={880}
                verticalAlignCenter
                onAfterClose={() => this.setState({ showDlgTrailer: null })}
            >
                <ReactPlayer
                    url={url}
                    playing
                    controls
                    width='100%'
                    height='100%'
                />
            </DialogWrapper2>
        );
    }

    validateEmail(mail: string): boolean {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(mail).toLowerCase());
    }
}
